import PropTypes from 'prop-types';
// import Chart from "react-google-charts";
import '../App.css';
import {useNavigate} from "react-router-dom";

const Diagnosis = ({change, data, sendDataToParent}) => {
    const navigate = useNavigate();
    const routeToRoot = () => {
        navigate('/')
        sendDataToParent('')
    }

    //<p>Calibrated rupture risk probability: {data.calibrated_probability} %</p>
    return (<div className="main-content">
        <div>
            <h1>Diagnosis</h1>
            <p>Rupture risk probability: <b>{data.probability} %</b></p>
            <div className="center">
                <button id="back-btn" className="button" type="button"
                        onClick={routeToRoot}><span>Back </span></button>
            </div>
        </div>
    </div>);
};


Diagnosis.propTypes =
    {
        change: PropTypes.func.isRequired
    }
;

export default Diagnosis;

/**
 <Chart
 width={'800px'}
 height={'400px'}
 chartType="PieChart"
 loader={<div>Loading Chart</div>}
 data={[
        ['Event', 'Probability'],
        ['SAH', 33],
        ['IBA', 9], // Below limit.
    ]}
 options={{
        title: 'SAH Incidence',
        sliceVisibilityThreshold: 0.2, // 20%
    }}
 rootProps={{'data-testid': '7'}}
 > */